import { FilterCategory } from "../enums/filter.enum";
import { IFilter } from "./general-filter";
import { inCampaign } from "./in-campaign-filter";

const reviewCount: IFilter = {
	name: "reviewCount",
	filterParam: "map_business.reviewCount",
	filterByType: ["isEmpty", "isNotEmpty", "greaterEqual", "lessEqual", "between"],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const rating: IFilter = {
	name: "rating",
	filterParam: "map_business.rating",
	filterByType: ["isEmpty", "isNotEmpty", "greaterEqual", "lessEqual", "between"],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const name: IFilter = {
	name: "name",
	filterParam: "map_business.name",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const email: IFilter = {
	name: "email",
	filterParam: "map_business.email",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const companyEmail: IFilter = {
	name: "companyEmail",
	filterParam: "map_business.companyEmail",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const companyName: IFilter = {
	name: "companyName",
	filterParam: "map_business.companyName",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const companyCountry: IFilter = {
	name: "companyCountry",
	filterParam: "map_business.companyCountry",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const type: IFilter = {
	name: "type",
	filterParam: "map_business.type",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const instagramUrl: IFilter = {
	name: "instagram",
	filterParam: "map_business.instagramUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const facebookUrl: IFilter = {
	name: "facebook",
	filterParam: "map_business.facebookUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const pinterestUrl: IFilter = {
	name: "pinterest",
	filterParam: "map_business.pinterestUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const githubUrl: IFilter = {
	name: "github",
	filterParam: "map_business.githubUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const youtubeUrl: IFilter = {
	name: "youtube",
	filterParam: "map_business.youtubeUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const twitterUrl: IFilter = {
	name: "twitter",
	filterParam: "map_business.twitterUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const snapchatUrl: IFilter = {
	name: "snapchat",
	filterParam: "map_business.snapchatUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

const yelpUrl: IFilter = {
	name: "yelp",
	filterParam: "map_business.yelpUrl",
	filterByType: [
		"isEmpty",
		"isNotEmpty",
		"textContains",
		"textDoesNotContain",
		"textStartsWith",
		"textEndsWith",
		"textIsExactly",
	],
	filterByValue: [],
	group: FilterCategory.MAPS,
};

export const MapsFilter: IFilter[] = [reviewCount, rating];

export const MapsAdditionalFilter: IFilter[] = [
	companyName,
	name,
	email,
	type,

	companyEmail,
	facebookUrl,
	instagramUrl,
	pinterestUrl,
	githubUrl,
	youtubeUrl,
	twitterUrl,
	snapchatUrl,
	yelpUrl,
];

export const MapsInboxAdditionalFilter: IFilter[] = [
	inCampaign,
	reviewCount,
	rating,
	companyCountry,
	companyName,
	name,
	email,
	type,
	companyEmail,
	facebookUrl,
	instagramUrl,
	pinterestUrl,
	githubUrl,
	youtubeUrl,
	twitterUrl,
	snapchatUrl,
	yelpUrl,
];
